/* Theme-local presentation only. Never changes HubSpot fields or submission settings. */
(() => {
  const css = `
    [data-rz-sales-panel] #rz-sales-embed {background:#0d151b!important;color:#fff!important;padding:16px 0!important;border-radius:0!important}
    @media(max-width:600px){[data-rz-inquiry-router]{padding:20px!important}}
    html.rzf-form-document,html.rzf-form-document body {background:#0d151b!important;color:#fff!important;margin:0!important}
    .hs-form, .submitted-message {font-family:Arial,Helvetica,sans-serif!important;color:#fff!important;font-size:16px!important;line-height:1.55!important}
    .hs-form * {box-sizing:border-box}
    .hs-form fieldset {max-width:100%!important}
    .hs-form .hs-form-field {margin-bottom:22px!important}
    .hs-form label {font-family:Arial,Helvetica,sans-serif!important;color:#fff!important;font-size:14px!important;font-weight:700!important;line-height:1.5!important;display:block;margin-bottom:8px}
    .hs-form .hs-input:not([type=checkbox]):not([type=radio]):not([type=hidden]) {font-family:Arial,Helvetica,sans-serif!important;font-size:16px!important;line-height:1.5!important;background:#070c10!important;color:#fff!important;border:1px solid #66747d!important;border-radius:2px!important;padding:12px!important;min-height:48px!important;width:100%!important;max-width:100%!important;box-shadow:none!important}
    .hs-form textarea.hs-input {min-height:130px!important;resize:vertical}
    .hs-form .hs-input::placeholder {color:#adb7be!important;opacity:1}
    .hs-form select.hs-input option {background:#070c10;color:#fff}
    .hs-form .hs-input:focus-visible,.hs-form .hs-button:focus-visible {outline:3px solid #00b2e3!important;outline-offset:3px}
    .hs-form input[type=checkbox],.hs-form input[type=radio] {accent-color:#00b2e3;width:20px!important;height:20px!important;margin-right:10px}
    .hs-form .hs-form-checkbox-display,.hs-form .hs-form-radio-display {font-weight:400!important;display:flex;align-items:flex-start}
    .hs-form .hs-form-required,.hs-form .hs-error-msgs label {color:#ffb4ab!important}
    .hs-form .hs-error-msgs {padding-left:0;list-style:none;margin:8px 0}
    .hs-form .hs-field-desc,.hs-form .legal-consent-container {color:#c5ced4!important;font-family:Arial,Helvetica,sans-serif!important;font-size:14px!important}
    .hs-form .legal-consent-container p,.hs-form .legal-consent-container span,.hs-form .legal-consent-container .hs-richtext {color:#c5ced4!important}
    .hs-form a,.submitted-message a {color:#00b2e3!important;text-decoration:underline}
    .hs-form .hs-button {font-family:Arial,Helvetica,sans-serif!important;font-size:14px!important;font-weight:700!important;letter-spacing:.07em!important;text-transform:uppercase;background:#00b2e3!important;color:#002a3c!important;border:2px solid #00b2e3!important;border-radius:2px!important;min-height:52px!important;padding:14px 24px!important;text-shadow:none!important;box-shadow:none!important;cursor:pointer}
    .hs-form .hs-button:hover {background:#002a3c!important;color:#fff!important;border-color:#00b2e3!important}
    .hs-form .actions {padding:8px 0!important;margin:0!important}
    .submitted-message {padding:24px!important;background:#0d151b!important;border-left:3px solid #00b2e3!important}
    @media(max-width:600px){.hs-form fieldset>div.hs-form-field {float:none!important;width:100%!important}.hs-form .input {margin-right:0!important}.hs-form .hs-button {width:100%!important}.hs-form fieldset {width:100%!important}}
  `;
  const watched = new WeakSet();
  function apply(doc) {
    if (!doc?.head || doc.getElementById('rzf-form-brand')) return;
    if (doc !== document) doc.documentElement.classList.add('rzf-form-document');
    const style = doc.createElement('style');
    style.id = 'rzf-form-brand';
    style.textContent = css;
    doc.head.appendChild(style);
  }
  function scan() {
    apply(document);
    document.querySelectorAll('iframe.hs-form-iframe').forEach(frame => {
      const update = () => {
        try { apply(frame.contentDocument); } catch (_) { /* Cross-origin forms retain their native style. */ }
      };
      if (!watched.has(frame)) { watched.add(frame); frame.addEventListener('load', update); }
      update();
    });
  }
  let queued = false;
  const schedule = () => {if (!queued) {queued = true; requestAnimationFrame(() => {queued = false;scan();});}};
  new MutationObserver(schedule).observe(document.documentElement, {childList:true,subtree:true});
  window.addEventListener('message', event => {
    if (event.data?.type === 'hsFormCallback') schedule();
  });
  scan();
})();
